import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "rentalContractConfirmModal" }
const _hoisted_2 = {
  class: "modal-title",
  id: "rentalContractConfirmModalLabel"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Registration = _resolveComponent("Registration")!
  const _component_Complete = _resolveComponent("Complete")!
  const _component_BsModal = _resolveComponent("BsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BsModal, {
      ref: "rentalContractConfirmModalRef",
      "modal-dialog-settings": ['modal-xl']
    }, {
      header: _withCtx(() => [
        _createElementVNode("h5", _hoisted_2, [
          (_ctx.confirmTypes.registration)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "登録確認"))
            : (_ctx.confirmTypes.complete)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "完了確認"))
              : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeRentalContractConfirmModal()))
        }, " キャンセル "),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickSubmitButton()))
        }, " 登録 ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.confirmTypes.registration)
            ? (_openBlock(), _createBlock(_component_Registration, { key: 0 }))
            : (_ctx.confirmTypes.complete)
              ? (_openBlock(), _createBlock(_component_Complete, { key: 1 }))
              : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}